import React from "react";
const Input = ({ textLabel, name, id, type, readonly, required = false, onchange = () => { }, value = null, placeholder = '', tailwindTheme = 'default', firstIcon = '', secondIcon = '', secondIconClick = () => { }, customTailwind = "" }) => {
    return (
        <div className={`${customTailwind}`}>
            {textLabel &&
                <label className={`text-${tailwindTheme}`}>{textLabel}</label>
            }
            <div className={`flex flex-row w-full h-full rounded-lg bg-white border-2 border-${tailwindTheme}`}>
                {firstIcon &&
                    <div className="mx-2 h-auto w-4 flex justify-center items-center">
                        <i className={`${firstIcon} text-${tailwindTheme}`}></i>
                    </div>
                }
                <div className="flex-1">
                    <input required={required} onChange={onchange} readOnly={readonly} type={type} className={`w-full h-full border-0 rounded-lg shadow-0 hover:border-0 focus:outline-none focus:ring-0 active:outline-none`} name={name} placeholder={placeholder} defaultValue={value}/>
                </div>
                {secondIcon &&
                    <div className="mx-2 h-auto w-4 flex justify-center items-center" onClick={secondIconClick}>
                        <i className={`${secondIcon} text-${tailwindTheme}`}></i>
                    </div>
                }
            </div>
        </div>
    )
}
export default Input
